<template>
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form :form="form" slot="detail">
          <a-row>
            <a-col :span="24">
              <a-form-item v-if="false" label="班级" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['deptId', validatorRules.deptId]" placeholder="请输入班级"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item v-if="false" label="课程" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['paperId', validatorRules.paperId]" placeholder="请输入课程"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="考试名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['examName', validatorRules.examName]" placeholder="请输入考试名称"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="开放方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-radio-group v-decorator="['openMethod', { initialValue: 1 }]" @change="onOpenMehtodChange">
                  <a-radio :value="0">不开放</a-radio>
                  <a-radio :value="1">直接开放</a-radio>
                  <a-radio :value="2">定时开放</a-radio>
                  <a-radio :value="3">完成某次考试后开放</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="model.openMethod == 2">
              <a-form-item label="考试开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-date placeholder="请选择考试开始时间" v-decorator="['startTime',validatorRules.startTime]" :dateFormat="'YYYY-MM-DD HH:mm:ss'" showTime
                  :trigger-change="true" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="model.openMethod == 2">
              <a-form-item label="考试结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-tooltip>
                  <template slot="title">
                    <p>超过结束时间将无法进入考场和交卷</p>
                    <p></p>
                  </template>
                  <j-date placeholder="请选择考试结束时间" v-decorator="['endTime',validatorRules.endTime]" :dateFormat="'YYYY-MM-DD HH:mm:ss'" showTime
                    :trigger-change="true" style="width: 100%" />
                </a-tooltip>
              </a-form-item>
            </a-col>
            <a-col :span="14" v-if="model.openMethod == 3">
              <a-form-item label="考试排期ID" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                <a-input v-decorator="['unlockPaperDeptId', validatorRules.unlockPaperDeptId]" placeholder="请输入考试排期ID"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10" v-if="model.openMethod == 3">
              <a-form-item label="分数要求" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                <a-input-number :min="0" :max="999" style="width:200px" v-decorator="['unlockScore', validatorRules.unlockScore]" placeholder="请输入分数"></a-input-number>
              </a-form-item>
            </a-col>
            <!-- <a-col :span="24">
              <a-form-item label="迟到限制" :labelCol="labelCol" :wrapperCol="wrapperCol">
                迟到
                <a-tooltip title="-1为不限次">
                  <a-input-number v-decorator="['lateTime']" :min="-1"
                    placeholder="请填写考试次数限制" />
                </a-tooltip>
                分钟不允许进入考场
              </a-form-item>
            </a-col> -->
            <a-col :span="24">
              <a-form-item label="考试次数" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-tooltip title="限制考试次数，-1为不限次">
                  <a-input-number v-decorator="['submitTimesLimit', validatorRules.submitTimesLimit]" :min="-1"
                    placeholder="请填写考试次数限制" />
                </a-tooltip>
              </a-form-item>
            </a-col>
            <a-divider>监考设置</a-divider>
            <a-col :span="24">
              <a-form-item label="页面跳出次数限制" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-tooltip title="切出考试页面后给予警告，超出次数后将强制中断考试。-1为不限制且不提醒">
                  <a-input-number v-decorator="['jumpOutLimit', validatorRules.jumpOutLimit]" :min="-1"
                    placeholder="请填写考试限时(分钟) 0不限" />
                </a-tooltip>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="摄像头监考" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-tooltip title="强制开启需要开启摄像头和麦克风才能进入考试！">
                  <a-radio-group v-decorator="['invigilateVideo', { initialValue: 0 }]"
                    @change="e => model.invigilateVideo = e.target.value">
                    <a-radio :value="2">强制开启</a-radio>
                    <a-radio :value="1">开启</a-radio>
                    <a-radio :value="0">关闭</a-radio>
                  </a-radio-group>
                </a-tooltip>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="录屏监考" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-radio-group v-decorator="['invigilateScreen', { initialValue: 0 }]"
                  @change="e => model.invigilateVideo = e.target.value">
                  <a-radio :value="2">强制开启</a-radio>
                  <a-radio :value="1">开启</a-radio>
                  <a-radio :value="0">关闭</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <!-- 
            <a-col :span="24">
              <a-form-item label="设备限制" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-radio-group v-decorator="['deviceLimit', { initialValue: 0 }]"
                  @change="e => model.deviceLimit = e.target.value">
                  <a-radio :value="2">仅手机</a-radio>
                  <a-radio :value="1">仅电脑</a-radio>
                  <a-radio :value="0">不限</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col> -->
  
            <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
              <a-button @click="submitForm">提 交</a-button>
            </a-col>
          </a-row>
        </a-form>
      </j-form-container>
    </a-spin>
  </template>
  
  <script>
  
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  
  export default {
    name: 'TeachingPaperDeptForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: () => { },
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          deptId: {
            rules: [
              { required: true, message: '请输入班级!' },
            ]
          },
          paperId: {
            rules: [
              { required: true, message: '请输入课程!' },
            ]
          },
          examName: {
            rules: []
          },
          openMethod: {
            rules: [
              { required: true, message: '请选择开始方式!' },
            ]
          },
          startTime: {
            rules: [
              { required: true, message: '请选择开始时间!' },
            ]
          },
          endTime: {
            rules: [
              { required: true, message: '请选择结束时间!' },
            ]
          },
          unlockPaperDeptId: {
            rules: [
              { required: true, message: '请填写考试排期ID!' },
            ]
          },
          unlockScore: {
            rules: [
              { required: true, message: '请填写分数要求!' },
            ]
          },
          submitTimesLimit: {
            rules: [{ required: true, message: '请输入考试次数限制!' }],
            initialValue: 1,
          },
          jumpOutLimit: {
            rules: [{ required: true, message: '请输入页面跳出次数限制!' }],
            initialValue: -1,
          }
        },
        url: {
          add: "/teaching/teachingPaperDept/add",
          edit: "/teaching/teachingPaperDept/edit",
          queryById: "/teaching/teachingPaperDept/queryById"
        }
      }
    },
    computed: {
      formDisabled() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return true
          }
        }
        return false
      }
    },
    created() {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add() {
        this.edit({});
      },
      edit(record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'createBy', 'createTime', 'updateBy', 'updateTime', 'sysOrgCode', 'deptId', 'paperId', 'startTime', 'endTime', 'unlockPaperDeptId','unlockScore', 'openMethod', 'examName', 'submitTimesLimit', 'jumpOutLimit', 'invigilateVideo', 'invigilateScreen', 'deviceLimit'))
        })
      },
      onOpenMehtodChange(e) {
        this.model.openMethod = e.target.value
      },
      //渲染流程表单数据
      showFlowData() {
        if (this.formBpm === true) {
          let params = { id: this.formData.dataId };
          getAction(this.url.queryById, params).then((res) => {
            if (res.success) {
              this.edit(res.result);
            }
          });
        }
      },
      submitForm() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据", formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
  
        })
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'createBy', 'createTime', 'updateBy', 'updateTime', 'sysOrgCode', 'deptId', 'paperId', 'startTime', 'endTime', 'openMethod'))
      },
    }
  }
  </script>